import * as Yup from 'yup';

export interface IProductForm {
  brandId: number | null;
  inputGroupCode: number | null;
  inputCode: number | null;
  inputGuid?: string | null;
  inputName?: string | null;
  subInput?: string | null;
  subInputCode?: number | null;
  name: string | null;
  title: string | null;
  description: string | null;
  price: string | null;
  producingCountry?: number | null;
  imagesId: number[] | [];
  imagesFile: File[] | [];

  weight?: number | null;
  weightUnit?: string | null;
  producingCompany?: string | null;
  formulation?: string | null;
  enginePower?: number | null;
  combinations?: string | null;
  application_method?: string | null;
}

export const brandProductSchema = Yup.object().shape({
  name: Yup.string().required('نام محصول را انتخاب کنید').nullable(),

  inputGroupCode: Yup.string().required('دسته محصول را انتخاب کنید').nullable(),

  subInput: Yup.string().required('نوع زیر محصول را انتخاب کنید').nullable(),

  inputGuid: Yup.string().required('نوع محصول را انتخاب کنید').nullable(),

  imagesFile: Yup.array()
    .min(1, 'تصویر محصول را وارد کنید')
    .required('تصویر محصول را وارد کنید')
    .nullable(),
});

export const initialValuesProduct = (brandId: number): IProductForm => {
  return {
    brandId,
    inputGroupCode: null,
    inputCode: null,
    inputGuid: null,
    inputName: null,
    subInput: null,
    name: null,
    title: null,
    description: null,
    price: null,
    producingCountry: null,
    imagesId: [],
    imagesFile: [],

    // Additional Data
    weight: null,
    weightUnit: null,
    producingCompany: null,
    formulation: null,
    enginePower: null,
  };
};
